import React from 'react';
import PropTypes from 'prop-types';
import { InfoCircle, InfoCircleSmall } from '@wix/wix-ui-icons-common';
import { TooltipCommonProps } from '../common/PropTypes/TooltipCommon';
import { dataHooks } from './constants';
import Tooltip from '../Tooltip';
import { st, classes } from './InfoIcon.st.css.js';
const iconComponentBySizeMap = {
    small: InfoCircleSmall,
    medium: InfoCircle,
};
const InfoIcon = ({ dataHook, content, size = 'medium', tooltipProps, className, children, }) => {
    const Icon = iconComponentBySizeMap[size];
    return (React.createElement("div", { className: st(classes.root, className), "data-size": size, "data-hook": dataHook },
        React.createElement(Tooltip, { ...tooltipProps, content: content, dataHook: dataHooks.tooltip }, children ?? React.createElement(Icon, { className: classes.icon }))));
};
InfoIcon.displayName = 'InfoIcon';
InfoIcon.propTypes = {
    dataHook: PropTypes.string,
    className: PropTypes.string,
    size: PropTypes.oneOf(['small', 'medium']),
    content: PropTypes.node.isRequired,
    tooltipProps: PropTypes.shape(TooltipCommonProps),
    children: PropTypes.node,
};
export default InfoIcon;
//# sourceMappingURL=InfoIcon.js.map